var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigGreenMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_1718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5 101C78.3904 101 101 78.3904 101 50.5C101 22.6096 78.3904 0 50.5 0C22.6096 0 0 22.6096 0 50.5C0 78.3904 22.6096 101 50.5 101Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5962 73.2807L63.5631 99.2476C85.0694 93.5125 101 73.9179 101 50.4999C101 50.022 101 49.5441 101 49.0662L80.6088 30.2681L37.5962 73.2807Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7747 61.8107C54.005 64.041 54.005 67.8643 51.7747 70.0946L47.1548 74.7145C44.9245 76.9448 41.1012 76.9448 38.8709 74.7145L18.639 54.3233C16.4087 52.093 16.4087 48.2697 18.639 46.0394L23.2589 41.4195C25.4892 39.1893 29.3125 39.1893 31.5428 41.4195L51.7747 61.8107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4578 26.6041C71.6881 24.3738 75.5114 24.3738 77.7417 26.6041L82.3616 31.224C84.5919 33.4543 84.5919 37.2776 82.3616 39.5079L47.3143 74.3959C45.084 76.6262 41.2607 76.6262 39.0304 74.3959L34.4105 69.776C32.1802 67.5457 32.1802 63.7224 34.4105 61.4921L69.4578 26.6041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_1718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigGreenMark);
export default __webpack_public_path__ + "static/media/bigGreenMark.2693e05a2c37fa586822e79bb2395ac9.svg";
export { ForwardRef as ReactComponent };